import { shopCLient } from '@/services/axiosConfig'
import { CartRes } from './types'

export type ClearCartResp = CartRes

type ClearCart = (isdn: string) => Promise<ClearCartResp>

export const clearCart: ClearCart = async (isnd) => {
  try {
    const res = await shopCLient.post(`/service/clear-cart?isdn=${isnd}`)
    return res.data.response
  } catch (e) {
    console.error(e)
  }
}
